import moment from "moment";

export function getFileIconImage(fileType) {
  if (fileType.endsWith("pdf")) {
    return "/images/file_icons/pdf.svg";
  }
  if (fileType.endsWith("docx") || fileType.endsWith("doc")) {
    return "/images/file_icons/word.svg";
  }
  if (fileType.endsWith("txt")) {
    return "/images/file_icons/txt.svg";
  }
  if (
    fileType.endsWith("png") ||
    fileType.endsWith("jpg") ||
    fileType.endsWith("jpeg")
  ) {
    return "/images/file_icons/img.svg";
  }
  if (
    fileType.endsWith("xlsx") ||
    fileType.endsWith("csv") ||
    fileType.endsWith("xls")
  ) {
    return "/images/file_icons/excel.svg";
  }
}

export function formatDate(date) {
  return moment(date).format("DD MMM YYYY");
}
